/**
 * Converts a Blob into { binary, mimeType } similar to getBinary().
 *
 * @param {Blob} blob
 * @returns {Promise<{ binary: string, mimeType: string }>}
 */
export default function blobToBinaryObject(blob) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onloadend = function () {
        try {
          const dataUrl = reader.result; // "data:application/pdf;base64,AAA..."
          const [mimePart, base64Part] = dataUrl.split(',');
          const mimeType = mimePart.replace('data:', '').replace(';base64', '');
          const binary = base64Part;

          resolve({ binary, mimeType });
        } catch (ex) {
          reject(ex);
        }
      };

      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(blob);
    } catch (err) {
      reject(err);
    }
  });
}
